var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "card-header d-flex justify-content-between"
  }, [_c('ul', {
    staticClass: "nav nav-tabs"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [(_vm.medicineType === 'hvlp') ? _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-hvlp'
    }
  }, [_vm._v("HVLP")]) : _c('button', {
    staticClass: "nav-link",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-hvlp'
    },
    on: {
      "click": function($event) {
        _vm.switchMedicineType('hvlp')
      }
    }
  }, [_vm._v("HVLP")])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item"
  }, [(_vm.medicineType === 'iplp') ? _c('span', {
    staticClass: "nav-link active",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-iplp'
    }
  }, [_vm._v("IPLP")]) : _c('button', {
    staticClass: "nav-link",
    attrs: {
      "data-testid": _vm.testIdPrefix + '-medicament-type-iplp'
    },
    on: {
      "click": function($event) {
        _vm.switchMedicineType('iplp')
      }
    }
  }, [_vm._v("IPLP")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card-body bg-info"
  }, [_c('div', {
    staticClass: "card-text"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveMedicament($event)
      }
    }
  }, [_c('div', {
    staticClass: "form-row align-items-end"
  }, [(_vm.medicineType === 'hvlp') ? _c('div', {
    staticClass: "col-sm-11 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchMedicine"
    }
  }, [_vm._v("Lék")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchMedicine",
      "label": "label",
      "track-by": "code",
      "open-direction": "bottom",
      "placeholder": "vyhledat lék",
      "options": _vm.medicines,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 400,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": "vybrat",
      "data-testid": _vm.testIdPrefix + '-medicament-search'
    },
    on: {
      "search-change": _vm.getResult,
      "select": _vm.selectMedicine
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title",
          class: props.option.available === true ? 'available' : 'unavailable'
        }, [_c('div', {
          staticClass: "row m-0 pb-0 font-sm"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [(props.option.has_actual_insruance_cover === true) ? _c('i', {
          staticClass: "fas fa-coins",
          staticStyle: {
            "color": "goldenrod"
          }
        }) : _vm._e(), _vm._v("\n                                  " + _vm._s(props.option.label) + "\n                                ")])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.medicamentError.medicine) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "medicineError"
    }
  }, [_vm._v(_vm._s(_vm.medicamentError.medicine.message))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.medicineType === 'iplp') ? _c('div', {
    staticClass: "col-sm-11 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchMedicine"
    }
  }, [_vm._v("Individuální léčivý přípravek")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchMedicine",
      "label": "name",
      "track-by": "id",
      "placeholder": "vyhledat lék",
      "options": _vm.individualMedicines,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": false,
      "selectLabel": "vybrat"
    },
    on: {
      "search-change": _vm.getIndividualMedicines,
      "select": _vm.selectIndividualMedicine
    },
    scopedSlots: _vm._u([{
      key: "option",
      fn: function(props) {
        return [_c('div', {
          staticClass: "option__desc"
        }, [_c('span', {
          staticClass: "option__title available"
        }, [_c('div', {
          staticClass: "row m-0 pb-1"
        }, [_c('div', {
          staticClass: "col-sm-6"
        }, [_vm._v("\n                                  " + _vm._s(props.option.name) + "\n                                ")])])])])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _vm._v(" "), (_vm.medicamentError.medicine) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "medicineError"
    }
  }, [_vm._v(_vm._s(_vm.medicamentError.medicine.message))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-1 mb-2"
  }, [(_vm.clientMedicineInfoPending === true) ? _c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-2x fa-fw"
  }) : _vm._e()])]), _vm._v(" "), (_vm.medicineType === 'iplp' && _vm.selected) ? _c('div', {
    staticClass: "form-row"
  }, [_c('span', {
    staticStyle: {
      "white-space": "pre"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.selected.preparation_process)
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "searchDiagnosis"
    }
  }, [_vm._v("Diagnóza")]), _vm._v(" "), _c('multiselect', {
    attrs: {
      "id": "searchDiagnosis",
      "label": "label",
      "track-by": "code",
      "placeholder": "vyhledat diagnózu",
      "options": _vm.diseases,
      "multiple": false,
      "searchable": true,
      "internal-search": false,
      "close-on-select": true,
      "options-limit": 300,
      "limit": 3,
      "max-height": 600,
      "show-no-results": false,
      "hide-selected": true,
      "selectLabel": ""
    },
    on: {
      "search-change": _vm.getDiseases,
      "select": _vm.selectDisease
    },
    model: {
      value: (_vm.selectedDisease),
      callback: function($$v) {
        _vm.selectedDisease = $$v
      },
      expression: "selectedDisease"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "paidBySick"
    }
  }, [_vm._v("Hradí pacient")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.paid_by_sick),
      expression: "medicament.paid_by_sick"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "paidBySick",
      "checked": "",
      "data-testid": _vm.testIdPrefix + '-medicament-paid-by-client'
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.paid_by_sick) ? _vm._i(_vm.medicament.paid_by_sick, null) > -1 : (_vm.medicament.paid_by_sick)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.paid_by_sick,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.paid_by_sick = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.paid_by_sick = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.paid_by_sick = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-begin"
  }, [_c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "amount"
    }
  }, [_vm._v("Počet balení")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.amount),
      expression: "medicament.amount"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "amount",
      "min": "1",
      "data-testid": _vm.testIdPrefix + '-medicament-amount'
    },
    domProps: {
      "value": (_vm.medicament.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.amount = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "dosage"
    }
  }, [_vm._v("Dávkování")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.dosage),
      expression: "medicament.dosage"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "operationHelp",
      "id": "dosage",
      "data-testid": _vm.testIdPrefix + '-medicament-dosage'
    },
    domProps: {
      "value": (_vm.medicament.dosage)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.dosage = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.medicamentError.dosage) ? _c('small', {
    staticClass: "form-text font-weight-bold",
    attrs: {
      "id": "dosageError"
    }
  }, [_vm._v(_vm._s(_vm.medicamentError.dosage.message))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "repeating"
    }
  }, [_vm._v("Opakování")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.repeating),
      expression: "medicament.repeating"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "repeating",
      "min": "2",
      "step": "1",
      "disabled": _vm.medicament.electronic_prescription !== true
    },
    domProps: {
      "value": (_vm.medicament.repeating)
    },
    on: {
      "change": _vm.repeatingChanged,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.repeating = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("Akutní")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.acute),
      expression: "medicament.acute"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "acute",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.acute) ? _vm._i(_vm.medicament.acute, null) > -1 : (_vm.medicament.acute)
    },
    on: {
      "change": _vm.acuteChanged,
      "__c": function($event) {
        var $$a = _vm.medicament.acute,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.acute = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.acute = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.acute = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "family"
    }
  }, [_vm._v("Rodina")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.family),
      expression: "medicament.family"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "family",
      "checked": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.family) ? _vm._i(_vm.medicament.family, null) > -1 : (_vm.medicament.family)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.family,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.family = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.family = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.family = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "separate"
    }
  }, [_vm._v("Samostatně")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-secondary disabled"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.separate),
      expression: "medicament.separate"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "separate",
      "checked": "",
      "disabled": ""
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.separate) ? _vm._i(_vm.medicament.separate, null) > -1 : (_vm.medicament.separate)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.separate,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.separate = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.separate = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.separate = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "validityInDays"
    }
  }, [_vm._v("Platnost (dní)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.validity_in_days),
      expression: "medicament.validity_in_days"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "aria-describedby": "operationHelp",
      "id": "validityInDays",
      "min": "1",
      "max": "365"
    },
    domProps: {
      "value": (_vm.medicament.validity_in_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.validity_in_days = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text font-weight-bold"
  }, [_vm._v("do " + _vm._s(_vm.validToDate))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-row align-items-end"
  }, [_c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "acute"
    }
  }, [_vm._v("E-RECEPT")]), _vm._v(" "), _c('div', [_c('label', {
    staticClass: "switch switch-lg switch-text switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.electronic_prescription),
      expression: "medicament.electronic_prescription"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "id": "type",
      "checked": "",
      "data-testid": _vm.testIdPrefix + '-medicament-electronic'
    },
    domProps: {
      "checked": Array.isArray(_vm.medicament.electronic_prescription) ? _vm._i(_vm.medicament.electronic_prescription, null) > -1 : (_vm.medicament.electronic_prescription)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.medicament.electronic_prescription,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.medicament.electronic_prescription = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.medicament.electronic_prescription = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.medicament.electronic_prescription = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "Ano",
      "data-off": "Ne"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "notification"
    }
  }, [_vm._v("Notifikace")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.patient_notification_type),
      expression: "medicament.patient_notification_type"
    }],
    staticClass: "form-control",
    attrs: {
      "aria-describedby": "notification",
      "id": "notification",
      "disabled": _vm.medicament.electronic_prescription !== true,
      "data-testid": _vm.testIdPrefix + '-medicament-notification'
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.medicament.patient_notification_type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.clientMedicineInfo.possible_notifications), function(pn, index) {
    return _c('option', {
      domProps: {
        "value": pn.key
      }
    }, [_vm._v(_vm._s(pn.label) + "\n              ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 mb-2"
  }, [_c('label', {
    attrs: {
      "for": "note"
    }
  }, [_vm._v("Poznámka")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.medicament.note),
      expression: "medicament.note"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "aria-describedby": "operationHelp",
      "id": "note",
      "data-testid": _vm.testIdPrefix + '-medicament-note'
    },
    domProps: {
      "value": (_vm.medicament.note)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.medicament.note = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit",
      "data-testid": _vm.testIdPrefix + '-medicament-add'
    }
  }, [_vm._v("Přidat lék")])])])])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae38258","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Prescribtion/AddMedicament.vue
// module id = 576
// module chunks = 0